import React from "react";
import { UserMenuButton as SharedUserMenuButton } from "@scoutingops/ui";
import type { UserMenuButtonProps as SharedProps } from "@scoutingops/ui";

const HUB_URL = (import.meta.env.VITE_HUB_URL ?? "https://scoutingops.com") as string;

export type UserMenuButtonProps = Pick<SharedProps, "avatarSize" | "onAction">;

// avatarSize is deliberately left undefined by default so the shared
// component's platform standard applies — don't restate a size here.
export function UserMenuButton({ avatarSize, onAction }: UserMenuButtonProps): React.JSX.Element {
  return (
    <SharedUserMenuButton
      avatarSize={avatarSize}
      onAction={onAction}
      accountUrl={`${HUB_URL}/account`}
      organizationUrl={`${HUB_URL}/unit`}
      afterSignOutUrl={HUB_URL}
    />
  );
}
